/**
 * Windows the top bar opens over the trading screen (owner 2026-10-04): the Rithmic login dialog
 * ("Add Rithmic account…" / "Log in to Rithmic…" in the Rithmic account control) and the Copy
 * trader pop-out (the "Copy" button). The shell mounts their hosts (TopBarDialogHosts.tsx); the
 * dialogs themselves load on first open. Like Settings, neither changes the saved dock layout.
 */
export type RithmicDialogMode = "add" | "login";

const rithmic = new Set<(mode: RithmicDialogMode) => void>();
const copy = new Set<() => void>();

export function openRithmicDialog(mode: RithmicDialogMode): void {
  for (const l of rithmic) l(mode);
}

export function onOpenRithmicDialog(l: (mode: RithmicDialogMode) => void): () => void {
  rithmic.add(l);
  return () => {
    rithmic.delete(l);
  };
}

export function openCopyTrader(): void {
  for (const l of copy) l();
}

export function onOpenCopyTrader(l: () => void): () => void {
  copy.add(l);
  return () => {
    copy.delete(l);
  };
}
